import { render, staticRenderFns } from "./DumbappEmbedSubmission.vue?vue&type=template&id=713c31e7&"
import script from "./DumbappEmbedSubmission.vue?vue&type=script&lang=js&"
export * from "./DumbappEmbedSubmission.vue?vue&type=script&lang=js&"
import style0 from "./DumbappEmbedSubmission.vue?vue&type=style&index=0&id=713c31e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports